export default __webpack_public_path__ + "static/media/lunchKeto.634fdf16.svg";